/* eslint-disable linebreak-style */
/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';
import Switch from 'react-ios-switch';
import FIELDS from '../../data/fields';

import InputComponent from '../elements/input';
import {
  loadSettings, loadSettingsLong, updateSettings, updateSettingsLong,
} from '../../app/store/actions/settings';
import DraftEditor from '../editor/draftEditor';
import SunEditor from '../editor/sunEditor';
import SelectComponent from '../select/Select';

class ParamsApp extends React.Component {
  constructor(props) {
    super(props);

    const UrlApp = [
      { name: I18n.t('screenHome'), value: 'ACTION_OPEN_HOME' },
      { name: I18n.t('screenProduct'), value: 'ACTION_OPEN_PRODUCTS' },
      { name: I18n.t('screenCart'), value: 'ACTION_OPEN_CART' },
    ];

    this.state = {
      message: '',
      success: '',
      popupBodyButtonLabelApp: null,
      popupBodyURLApp: '',
      popupEnabledApp: null,
      popupBodyApp: null,
      UrlApp,
      parametersUrl: '',
    };
  }

  async componentDidMount() {
    await this.props.loadSettings();
    const settingsLong = await this.props.loadSettingsLong();

    const {
      popupBodyButtonLabelApp,
      popupBodyURLApp,
      popupEnabledApp,
    } = this.props.settings;

    let urlInternal = '';
    let parametersUrl = '';
    if (popupBodyURLApp) {
      const result = JSON.parse(popupBodyURLApp);
      // eslint-disable-next-line prefer-destructuring
      urlInternal = result.urlInternal;
      delete result.urlInternal;
      parametersUrl = (Object.keys(result).length)
        ? Object.entries(result).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')
        : '';
    }
    this.setState({
      ...settingsLong ? {
        settingsLong,
        popupBodyApp: settingsLong.popupBodyApp,
      } : {},
      popupBodyButtonLabelApp,
      popupBodyURLApp: urlInternal,
      popupEnabledApp,
      parametersUrl,
    });
  }

  formatUrlParameters = (parametersUrl, urlInternal) => {
    const result = parametersUrl.split('?');
    const paramString = (result.length === 2) ? result[1].split('&') : result[0].split('&');

    const queryParams = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const query of paramString) {
      const [key, value] = query.split('=');
      queryParams[key] = decodeURIComponent(value);
    }
    return JSON.stringify({ urlInternal, ...queryParams });
  }

  uploadedFile = async () => {
    const {
      popupBodyButtonLabelApp,
      popupBodyURLApp,
      popupEnabledApp,
      popupBodyApp,
      parametersUrl,
    } = this.state;
    const {
      updateSettings, updateSettingsLong, isChile,
    } = this.props;

    let popupBodyCheckApp = popupBodyApp.trim();

    if (popupBodyCheckApp.substring(0, 5) !== '<div>'
      || popupBodyCheckApp.substring(popupBodyCheckApp.length - 6) !== '<div>') {
      popupBodyCheckApp = `<div>${popupBodyCheckApp}</div>`;
    }

    let newUrlInternal = JSON.stringify({ urlInternal: popupBodyURLApp });
    if (parametersUrl) newUrlInternal = this.formatUrlParameters(parametersUrl, popupBodyURLApp);

    try {
      if (isChile) {
        await updateSettings({
          popupBodyButtonLabelApp,
          popupBodyURLApp: newUrlInternal,
          popupEnabledApp,
        });
        await updateSettingsLong({
          popupBodyApp: popupBodyCheckApp,
        });
      } else {
        await updateSettings({
          popupBodyButtonLabelApp,
          popupBodyURLApp,
          popupEnabledApp,
          popupBodyApp: popupBodyCheckApp,
        });
      }

      await this.setState({ message: '', success: I18n.t('saved') });
    } catch (err) {
      await this.setState({ message: I18n.t('errorOcurred'), success: '' });
    }
  }

  setHtml = async () => {
    await this.setState({ message: '', success: '' });
  }

  setHtmlPopupBodyApp = async (popupBodyApp) => {
    await this.setState({ popupBodyApp, message: '', success: '' });
  }

  render() {
    const {
      message,
      success,
      popupBodyButtonLabelApp,
      popupBodyURLApp,
      popupEnabledApp,
      popupBodyApp = '',
      parametersUrl,
    } = this.state;

    const { isChile } = this.props;

    if (isChile && !this.state.settingsLong) {
      return (<React.Fragment />);
    }

    return (
      <React.Fragment>
        <div className="layout-params-div">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p className="margin-bottom-2"><Translate value="popupBody" /></p>
            <Switch
              checked={!!popupEnabledApp && popupEnabledApp.trim() === 'true'}
              className="margin-bottom-2"
              style={{ marginLeft: 10 }}
              onChange={value => this.setState({ popupEnabledApp: value ? 'true' : 'false' })}
            />
          </div>

          {isChile
            ? <SunEditor content={popupBodyApp} setHtml={this.setHtmlPopupBodyApp} />
            : <DraftEditor value={popupBodyApp} setHtml={this.setHtmlPopupBodyApp} />
          }

          {isChile && (
            <InputComponent
              type="text"
              title={I18n.t('popupBodyButtonLabel')}
              className="form-control"
              placeHolder=""
              onChange={e => this.setState({ popupBodyButtonLabelApp: e.target.value, message: '', success: '' })}
              value={popupBodyButtonLabelApp}
              maxLength={FIELDS.default}
            />
          )}
          {
            isChile
            && (
              <SelectComponent
                title={I18n.t('popupBodyURL')}
                value={popupBodyURLApp}
                body={this.state.UrlApp.map(val => (<option key={val.value} value={val.value}>{val.name}</option>))}
                onChange={e => this.setState({
                  popupBodyURLApp: e.target.value,
                  message: '',
                  success: '',
                  parametersUrl: '',
                })}
              />
            )
          }
          {(popupBodyURLApp === 'ACTION_OPEN_PRODUCTS') && (
            <div className="form-group">
              <p className="margin-bottom-2">
                {I18n.t('filterProducts')}
              </p>
              <input
                type="text"
                onChange={e => this.setState({ parametersUrl: `${e.target.value}` })}
                value={parametersUrl}
                className="form-control"
              />
            </div>
          )}
        </div>
        <button
          onClick={() => this.uploadedFile()}
          type="button"
          className="btn btn-secondary margin-bottom-20"
        >
          <Translate value="save" />
        </button>

        {success && <p className="color-green margin-top-10">{success}</p>}
        {message && <p className="color-red margin-top-10">{message}</p>}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  isChile: state.settings && state.settings.companyTag === 'chile',
});

const mapDispatchToProps = dispatch => ({
  loadSettings: () => dispatch(loadSettings()),
  loadSettingsLong: () => dispatch(loadSettingsLong()),
  updateSettings: settings => dispatch(updateSettings(settings)),
  updateSettingsLong: settingsLong => dispatch(updateSettingsLong(settingsLong)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ParamsApp);
